// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__EVOeJ","info":"PatientInfo_info__2bYjG"};